import { queries } from 'apollo';
import * as React from 'react';
import { Query, QueryResult } from 'react-apollo';
import { Subtract } from 'utility-types';

interface IPartnersPageDataResult {
  fetch: {
    Common: {
      Partners: {
        BackgroundColor: string | null;
        HighlightColor: string | null;
      } | null;
    };
    Country: {
      AboutPage: {
        Partners: Array<{
          Name: string;
          Content: string;
          PartnerImage: {
            src: string;
          };
        }> | null;
      };
    };
  };
}

interface IVariables {
  filters: {
    UrlKey: string;
  };
}

interface IRequiredProps {
  country: string;
}

export type WithPartnersPageQueryProps = QueryResult<IPartnersPageDataResult>;

class PartnersPageQuery extends Query<IPartnersPageDataResult, IVariables> {}

const withPartnersPageQuery = <P extends WithPartnersPageQueryProps>(
  Component: React.ComponentType<P>
): React.SFC<
  Subtract<P, WithPartnersPageQueryProps> & IRequiredProps
> => props => {
  const { country } = props;
  return (
    <PartnersPageQuery
      query={queries.GET_PARTNERS_PAGE_DATA}
      variables={{
        filters: { UrlKey: country }
      }}
    >
      {providedProps => <Component {...providedProps} {...props as any} />}
    </PartnersPageQuery>
  );
};

export default withPartnersPageQuery;



// WEBPACK FOOTER //
// ./src/enhancers/withPartnersPageQuery.tsx